import { render, staticRenderFns } from "./WelcomeStep.vue?vue&type=template&id=2614b1d8&scoped=true"
import script from "./WelcomeStep.vue?vue&type=script&lang=js"
export * from "./WelcomeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2614b1d8",
  null
  
)

export default component.exports